import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Car, Bike, Truck, ShieldAlert, ShieldCheck, Timer, Zap, MapPin, Wrench } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const MotorInsurance = () => {
    const { t } = useLanguage();

    const motorPlans = [
        { key: 'ft_motor_car', icon: Car, desc: 'Highest medical coverage for yourself with paperless claim settlement.' },
        { key: 'ft_motor_bike', icon: Bike, desc: 'Coverage for two-wheelers including theft and third-party liability.' },
        { key: 'ft_motor_comm', icon: Truck, desc: 'Commercial vehicle insurance for businesses with fast claim process.' },
        { key: 'ft_motor_third', icon: ShieldAlert, desc: 'Mandatory third-party liability cover for all vehicle types.' },
        { key: 'ft_motor_compre', icon: ShieldCheck, desc: 'Full protection against own-damage, theft, and natural calamities.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_motor')}
                subtitle="Your journey is precious. Experience stress-free drives with our award-winning motor insurance portfolio."
                bgGradient={true}
                image="/assets/motor-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Drive with Confidence</h2>
                    <p className="section-subtitle">We protect your car, your bike, and your business with tailored motor plans.</p>
                </div>
                
                <div className="grid grid-3">
                    {motorPlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Superior Motor Care</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <Timer className="feature-icon" />
                            <h4>Fast Claim Approval</h4>
                            <p>Get claim approvals within 60 minutes with our smart digital photo-inspection.</p>
                        </div>
                        <div className="feature-item">
                            <Zap className="feature-icon" />
                            <h4>Zero-Depreciation</h4>
                            <p>Full claim amount without any deductions for depreciation on parts replacement.</p>
                        </div>
                        <div className="feature-item">
                            <MapPin className="feature-icon" />
                            <h4>Roadside Assistance</h4>
                            <p>24/7 towing, battery jumpstarts, and flat-tire repair wherever you are in India.</p>
                        </div>
                        <div className="feature-item">
                            <Wrench className="feature-icon" />
                            <h4>Cashless Garages</h4>
                            <p>Choose from 5,000+ top-rated network garages for zero-hassle repairs.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Renew in Under 2 Minutes</h3>
                    <p>Enter your vehicle number for an instant renewal or new policy quote.</p>
                    <button className="btn btn-primary" onClick={() => window.location.href='/contact'}>Get Instant Quote</button>
                </div>
            </div>
        </div>
    );
};

export default MotorInsurance;
